export default {
    "name": "InterchangeScreenData",
    "kind": "HoudiniQuery",
    "hash": "104a21cea9e4724b4b9d6b98af0f9eb34423ce1534ffa687ca145bc3c1f3e131",

    "raw": `query InterchangeScreenData($inventoryTypeFilter: InventoryTypeFilter) {
  inventoryTypes(filter: $inventoryTypeFilter) {
    id
    name
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventoryTypes": {
                "type": "InventoryType",
                "keyRaw": "inventoryTypes(filter: $inventoryTypeFilter)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "inventoryTypeFilter": "InventoryTypeFilter"
        },

        "types": {
            "InventoryTypeFilter": {
                "active": "Boolean",
                "vehicle": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=375bd586b2d1dd252b16da077c41c392f732c53ad1304f598c3a01f99281db59";